/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */

export type SavedReportType2 =
    (typeof SavedReportType2)[keyof typeof SavedReportType2];

export const SavedReportType2 = {
    status: "status",
    workload: "workload",
    classification: "classification",
} as const;
